import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { SCHEMA_STORAGE_KEY } from '../services/SchemaService';

export const getTitleFromSchema = (defaultTitle: string, fieldPath: string): string => {
  const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
  const field = schema?.[fieldPath]?.formFields?.[0];
  
  return field?.label
    ? `Para iniciar, digite seu ${field.label}.`
    : defaultTitle;
};
